import { useDeviceDetect } from '@fable/hooks'
import { DownloadAppQRCallout } from 'components/marketing_landing_page/download_app_callout/DownloadAppQRCallout'
import { MLPDownloadAppCard } from './MLPDownloadAppCard'

export const MLPDownloadAppCallout = () => {
  const { isMobile } = useDeviceDetect()

  if (isMobile) return <MLPDownloadAppCard />

  return <DownloadAppQRCallout />
}
